export default {
  boardData: {},
  list: [],
  types: [],
  postListInfo: {
    // current_page:0, // 현재페이지
    // data: [], // 실제데이터
    // first_page_url:'', // 처음페이지 주소
    // last_page_url:'', // 마지막페이지 주소
    // next_page_url:'', // 다음페이지
    // prev_page_url:'', // 이전페이지
    // from:0, // 게시글 시작번호
    // to:0, // 게시글 마지막번호
    // total:0, // 총 게시글수
    // per_page:0, // 페이지당 게시글
    // last_page:0, // 마지막페이지
  },
  postInfo: {},
  postIds: [],
  commentList: [],
  deleteSuccess: false,
  photoList: [],
  fileList: [],
  uploadFileList: [],
  downloadFile: {},
  boardConnect823: null, // 823Board에서 사용하는 개선전,개선후 페이지 아이디를 저장함
  riskAssessment: {},
  // 게시글 숨김 기능 관련 state
  hiddenPostList: [], // 숨겨진 게시글 목록
  hiddenPostListInfo: {}, // 숨겨진 게시글 목록 페이지네이션 정보
  postHiddenStatus: {}, // 게시글 숨김 상태 정보
  bulkHideResult: {}, // 일괄 숨김 처리 결과
  bulkUnhideResult: {}, // 일괄 숨김 해제 결과
  isSafetyManager: false,
};
